import { Pipe, PipeTransform } from "@angular/core";
import { TimeService } from "@app2/shared/services/time.service";

@Pipe({ name: "shortDateAndTime" })
export class ShortDateAndTimePipe implements PipeTransform {
    constructor(private timeService: TimeService) {
    }

    transform(time: string | Moment): string {
        const timestamp = this.timeService.timeZoneMoment(time);

        const todayBegin = this.timeService.now().startOf("day");
        const todayEnd = this.timeService.now().endOf("day");

        return timestamp.isBetween(todayBegin, todayEnd)
            ? timestamp.format(this.timeService.formats.timeMeridiem)
            : `${ timestamp.format(this.timeService.formats.timestampDate) } at ${ timestamp.format(this.timeService.formats.timeMeridiem) }`;
    }
}
